import TextInput from "components/form/input/TextInput"
import {
    GenericParamFields,
    ParamFormRow
} from "entity/Indicador/components/ParamFields"
import Perf from ".."

export function PerfParamFields({ tipoIndicadorField }) {
    return (
        <GenericParamFields
            name={Perf.field + tipoIndicadorField}
            tabFields={
                <>
                    <ParamFormRow label="Metros Avaliados">
                        <TextInput name="metrosAvaliados" label="Valor (m)" type="number" />
                    </ParamFormRow> 
                </>
            }
        />
    );
}
